module.exports = __webpack_public_path__ + "files/534a00763259bf994fb58d241abfecfe.png";